import { render, staticRenderFns } from "./BulletinCommentItem.vue?vue&type=template&id=8dff8966&scoped=true&"
import script from "./BulletinCommentItem.vue?vue&type=script&lang=ts&"
export * from "./BulletinCommentItem.vue?vue&type=script&lang=ts&"
import style0 from "./BulletinCommentItem.vue?vue&type=style&index=0&id=8dff8966&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dff8966",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VImg,VRow})
